import { render } from "./Testimonials.vue?vue&type=template&id=00e8cf03&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=js"
export * from "./Testimonials.vue?vue&type=script&lang=js"

import "./Testimonials.vue?vue&type=style&index=0&id=00e8cf03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e8cf03"]])

export default __exports__